var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/util/react-router-helpers.tsx";
const _excluded = ["component", "page", "content", "componentParams", "layout", "publicRoute", "staffOnly", "adminOnly", "developerOnly"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { Layout } from 'soapbox/components/ui';
import { useOwnAccount, useSettings } from 'soapbox/hooks';
import BundleColumnError from '../components/bundle-column-error';
import ColumnForbidden from '../components/column-forbidden';
import ColumnLoading from '../components/column-loading';
import ColumnsArea from '../components/columns-area';
import BundleContainer from '../containers/bundle-container';

const WrappedRoute = _ref => {
  let {
    component,
    page: Page,
    content,
    componentParams = {},
    layout,
    publicRoute = false,
    staffOnly = false,
    adminOnly = false,
    developerOnly = false
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const history = useHistory();
  const account = useOwnAccount();
  const settings = useSettings();

  const renderComponent = _ref2 => {
    let {
      match
    } = _ref2;

    if (Page) {
      return /*#__PURE__*/React.createElement(BundleContainer, {
        fetchComponent: component,
        loading: renderLoading,
        error: renderError,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 9
        }
      }, Component => /*#__PURE__*/React.createElement(Page, _extends({
        params: match.params,
        layout: layout
      }, componentParams, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 15
        }
      }), /*#__PURE__*/React.createElement(Component, _extends({
        params: match.params
      }, componentParams, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 17
        }
      }), content)));
    }

    return /*#__PURE__*/React.createElement(BundleContainer, {
      fetchComponent: component,
      loading: renderLoading,
      error: renderError,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 7
      }
    }, Component => /*#__PURE__*/React.createElement(ColumnsArea, {
      layout: layout,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Component, _extends({
      params: match.params
    }, componentParams, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 15
      }
    }), content)));
  };

  const renderWithLayout = children => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 7
    }
  }));

  const renderLoading = () => renderWithLayout( /*#__PURE__*/React.createElement(ColumnLoading, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 48
    }
  }));

  const renderForbidden = () => renderWithLayout( /*#__PURE__*/React.createElement(ColumnForbidden, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 50
    }
  }));

  const renderError = props => renderWithLayout( /*#__PURE__*/React.createElement(BundleColumnError, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 56
    }
  })));

  const loginRedirect = () => {
    const actualUrl = encodeURIComponent("".concat(history.location.pathname).concat(history.location.search));
    localStorage.setItem('soapbox:redirect_uri', actualUrl);
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/login",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97,
        columnNumber: 12
      }
    });
  };

  const authorized = [account || publicRoute, developerOnly ? settings.get('isDeveloper') : true, staffOnly ? account && account.staff : true, adminOnly ? account && account.admin : true].every(c => c);

  if (!authorized) {
    if (!account) {
      return loginRedirect();
    } else {
      return renderForbidden();
    }
  }

  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: renderComponent,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 10
    }
  }));
};

export { WrappedRoute };